import "./MainNavigation/main-navigation";

// Select the navigation bar
const header = document.querySelector<HTMLElement>("#site-header");

if (header) {
  let isFlyoutOpen = false;

  const animate = header.dataset.animate === "true";

  let lastScrollY = window.scrollY;
  let isVisible = true;

  const handleScroll = () => {
    if (isFlyoutOpen) {
      // While any flyout is open, don't hide the header.
      return;
    }

    const currentScrollY = window.scrollY;
    const headerSlotHeight = header.clientHeight;
    const scrolledPastThreshold = currentScrollY > headerSlotHeight;

    // Handle position based on scroll direction.
    // Allow scrolling down a little bit (no matter where on the page) before hiding the header.
    if (scrolledPastThreshold && currentScrollY > lastScrollY) {
      if (isVisible) {
        header.classList.add("-translate-y-full");
        isVisible = false;
      }
    } else if (currentScrollY < lastScrollY) {
      if (!isVisible) {
        header.classList.remove("-translate-y-full");
        isVisible = true;
      }
    }

    lastScrollY = currentScrollY;
  };

  if (animate) {
    window.addEventListener("scroll", handleScroll, { passive: true });

    header.addEventListener("flyout:open", () => {
      isFlyoutOpen = true;
    });

    header.addEventListener("flyout:close", () => {
      isFlyoutOpen = false;
    });
  }
}
